import socket from './socket';

/* Actions */

const getModels = (headers) =>
  socket.get(`/models`, undefined, headers).then((body) => ({
    ...body,
    items: body.items,
    included: {
      ...body.included,
    },
  }));

const createModel = (data, headers) => socket.post('/models', data, headers);

const updateModel = (id, data, headers) => socket.patch(`/models/${id}`, data, headers);

const deleteModel = (id, headers) => socket.delete(`/models/${id}`, undefined, headers);

export default {
  getModels,
  createModel,
  updateModel,
  deleteModel,
};
